var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload1BackgroundSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 809,
    viewBox: "0 0 376 809",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_100_1036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 376,
    height: 809
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 373,
    height: 806,
    rx: 51.5,
    fill: "#EBF5FF",
    fillOpacity: 0.3,
    stroke: "url(#paint0_linear_100_1036)",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_100_1036)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_100_1036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.238 612.007C317.89 612.007 331.581 602.642 343.8 586.338C356.038 570.008 366.996 546.473 376.172 517.526C394.53 459.613 405.86 379.702 405.86 291.5C405.86 203.298 394.53 123.386 376.172 65.4743C366.996 36.527 356.038 12.9922 343.8 -3.33796C331.581 -19.6418 317.89 -29.0076 303.238 -29.0076C288.586 -29.0076 274.895 -19.6418 262.676 -3.33796C250.437 12.9922 239.479 36.527 230.303 65.4743C211.946 123.386 200.615 203.298 200.615 291.5C200.615 379.702 211.946 459.613 230.303 517.526C239.479 546.473 250.437 570.008 262.676 586.338C274.895 602.642 288.586 612.007 303.238 612.007Z",
    fill: "#C1BCFF",
    stroke: "url(#paint1_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9819 685.892C87.6338 685.892 101.325 676.527 113.544 660.223C125.782 643.893 136.74 620.358 145.916 591.411C164.274 533.499 175.604 453.587 175.604 365.385C175.604 277.183 164.274 197.271 145.916 139.359C136.74 110.412 125.782 86.8772 113.544 70.5471C101.325 54.2432 87.6338 44.8774 72.9819 44.8774C58.33 44.8774 44.639 54.2432 32.4201 70.5471C20.1815 86.8772 9.22363 110.412 0.0475922 139.359C-18.31 197.271 -29.6406 277.183 -29.6406 365.385C-29.6406 453.587 -18.31 533.499 0.0475922 591.411C9.22363 620.358 20.1815 643.893 32.4201 660.223C44.639 676.527 58.33 685.892 72.9819 685.892Z",
    fill: "#C1BCFF",
    stroke: "url(#paint2_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3772 629.393C71.9345 629.393 82.6778 622.01 92.2159 609.291C101.774 596.545 110.317 578.198 117.466 555.66C131.768 510.568 140.59 448.367 140.59 379.727C140.59 311.088 131.768 248.887 117.466 203.795C110.317 181.257 101.774 162.91 92.2159 150.164C82.6778 137.445 71.9345 130.062 60.3772 130.062C48.8198 130.062 38.0765 137.445 28.5384 150.164C18.9807 162.91 10.4372 181.257 3.28879 203.795C-11.0136 248.887 -19.8359 311.088 -19.8359 379.727C-19.8359 448.367 -11.0136 510.568 3.28879 555.66C10.4372 578.198 18.9807 596.545 28.5384 609.291C38.0765 622.01 48.8198 629.393 60.3772 629.393Z",
    fill: "#FFD9DD",
    stroke: "url(#paint3_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.381 624.177C178.938 624.177 189.682 616.794 199.22 604.074C208.778 591.329 217.321 572.982 224.469 550.444C238.772 505.352 247.594 443.151 247.594 374.511C247.594 305.872 238.772 243.671 224.469 198.579C217.321 176.041 208.778 157.694 199.22 144.948C189.682 132.229 178.938 124.846 167.381 124.846C155.824 124.846 145.08 132.229 135.542 144.948C125.985 157.694 117.441 176.041 110.293 198.579C95.9903 243.671 87.168 305.872 87.168 374.511C87.168 443.151 95.9903 505.352 110.293 550.444C117.441 572.982 125.985 591.329 135.542 604.074C145.08 616.794 155.824 624.177 167.381 624.177Z",
    fill: "#DEB5FF",
    stroke: "url(#paint4_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3117 838.007C109.902 838.007 119.724 831.245 128.424 819.647C137.144 808.024 144.933 791.299 151.448 770.767C164.483 729.686 172.522 673.026 172.522 610.507C172.522 547.989 164.483 491.329 151.448 450.248C144.933 429.716 137.144 412.991 128.424 401.368C119.724 389.77 109.902 383.008 99.3117 383.008C88.7215 383.008 78.8994 389.77 70.199 401.368C61.479 412.991 53.69 429.716 47.1752 450.248C34.1401 491.329 26.1016 547.989 26.1016 610.507C26.1016 673.026 34.1401 729.686 47.1752 770.767C53.69 791.299 61.479 808.024 70.199 819.647C78.8994 831.245 88.7215 838.007 99.3117 838.007Z",
    fill: "#C173FF",
    stroke: "url(#paint5_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.212 745C157.802 745 167.624 738.237 176.325 726.64C185.045 715.016 192.834 698.291 199.349 677.76C212.384 636.678 220.422 580.018 220.422 517.5C220.422 454.981 212.384 398.321 199.349 357.24C192.834 336.708 185.045 319.984 176.325 308.36C167.624 296.762 157.802 290 147.212 290C136.622 290 126.8 296.762 118.099 308.36C109.379 319.984 101.59 336.708 95.0756 357.24C82.0405 398.321 74.002 454.981 74.002 517.5C74.002 580.018 82.0405 636.678 95.0756 677.76C101.59 698.291 109.379 715.016 118.099 726.64C126.8 738.237 136.622 745 147.212 745Z",
    fill: "#C173FF",
    stroke: "url(#paint6_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.854 676.331C306.591 676.331 318.458 668.194 329.019 654.111C339.598 640.002 349.062 619.682 356.984 594.706C372.832 544.737 382.611 475.8 382.611 399.719C382.611 323.639 372.832 254.701 356.984 204.733C349.062 179.757 339.598 159.437 329.019 145.328C318.458 131.245 306.591 123.108 293.854 123.108C281.117 123.108 269.25 131.245 258.69 145.328C248.11 159.437 238.646 179.757 230.725 204.733C214.876 254.701 205.098 323.639 205.098 399.719C205.098 475.8 214.876 544.737 230.725 594.706C238.646 619.682 248.11 640.002 258.69 654.111C269.25 668.194 281.117 676.331 293.854 676.331Z",
    fill: "#AAEBFF",
    stroke: "url(#paint7_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0607 456.416C77.1745 456.416 84.0646 449.503 88.838 439.39C93.6663 429.16 96.6117 415.133 96.6117 399.72C96.6117 384.307 93.6663 370.28 88.838 360.05C84.0646 349.936 77.1745 343.024 69.0607 343.024C60.947 343.024 54.0568 349.936 49.2834 360.05C44.4552 370.28 41.5098 384.307 41.5098 399.72C41.5098 415.133 44.4552 429.16 49.2834 439.39C54.0568 449.503 60.947 456.416 69.0607 456.416Z",
    fill: "#FFDA58",
    stroke: "url(#paint8_linear_100_1036)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0607 435.553C77.1745 435.553 84.0646 428.641 88.838 418.527C93.6663 408.297 96.6117 394.27 96.6117 378.857C96.6117 363.444 93.6663 349.417 88.838 339.187C84.0646 329.074 77.1745 322.161 69.0607 322.161C60.947 322.161 54.0568 329.074 49.2834 339.187C44.4552 349.417 41.5098 363.444 41.5098 378.857C41.5098 394.27 44.4552 408.297 49.2834 418.527C54.0568 428.641 60.947 435.553 69.0607 435.553Z",
    fill: "#FFDD65",
    stroke: "url(#paint9_linear_100_1036)",
    strokeWidth: 3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_100_1036",
    x: -314.731,
    y: -314.098,
    width: 1005.68,
    height: 1437.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 141.795,
    result: "effect1_foregroundBlur_100_1036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_100_1036",
    x1: 373,
    y1: 3,
    x2: -121.623,
    y2: 88.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_100_1036",
    x1: 303.238,
    y1: -27.5076,
    x2: 303.238,
    y2: 610.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_100_1036",
    x1: 72.9819,
    y1: 46.3774,
    x2: 72.9819,
    y2: 684.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_100_1036",
    x1: 60.3772,
    y1: 131.562,
    x2: 60.3772,
    y2: 627.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_100_1036",
    x1: 167.381,
    y1: 126.346,
    x2: 167.381,
    y2: 622.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_100_1036",
    x1: 99.3117,
    y1: 384.508,
    x2: 99.3117,
    y2: 836.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_100_1036",
    x1: 147.212,
    y1: 291.5,
    x2: 147.212,
    y2: 743.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_100_1036",
    x1: 293.854,
    y1: 124.608,
    x2: 293.854,
    y2: 674.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_100_1036",
    x1: 69.0607,
    y1: 344.524,
    x2: 69.0607,
    y2: 454.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_100_1036",
    x1: 69.0607,
    y1: 323.661,
    x2: 69.0607,
    y2: 434.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload1BackgroundSmall);
export default __webpack_public_path__ + "static/media/download-1-background-small.5051e2d0cef7f06a7ef2607db3b296e1.svg";
export { ForwardRef as ReactComponent };